<div class='full-form' [ngClass]='formConfig.formStyle'>
  <language-select
    [selected]='appService.language.value'
    (changed)='appService.language.next($event)'
    [languageCodes]='appService.supportedLanguageCodes'
  [activeLanguageCodes]='reselledDatasetMCS.activeLanguageCodes'></language-select>

  @if (datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }

  @if (datasetACS.ready.value) {
    <div class='mt-24'>
      @if (!datasetRS.record.value && !datasetACS.loading.value) {
        <p>{{'Questa traduzione non è ancora presente!' | translate}}</p>
      }
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Dati originali
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          @if (originalDatasetRS.record.value) {
            <data-container-viewer
              [dataContainerService]='datasetACS'
              [fields]='stepConfig.options.fields'
              [record]='originalDatasetRS.record.value'
            ></data-container-viewer>
          }
        </mat-expansion-panel>
      </mat-accordion>
      <form-viewer
        #formViewer
        [dataContainerService]='datasetACS'
        [formConfig]='formConfig'
        [record]='datasetRS.record.value'
      ></form-viewer>
      <div class="mt-24 mb-24 fx-row fx-justify-end fx-items-center" style="gap: 10px">
        <button color='accent' [disabled]='datasetACS.loading.value' mat-flat-button (click)='onSave()'>
          @if (!datasetACS.loading.value) {
            <span>{{ (hasNext ? "Salva e vai avanti" : "Salva") | translate }}</span>
          }
          @if (datasetACS.loading.value) {
            <span>{{'Azione in corso...' | translate}}</span>
          }
        </button>
      </div>
    </div>
  }
</div>